import script from "./QusList.vue?vue&type=script&setup=true&lang=js"
export * from "./QusList.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./QusList.vue?vue&type=custom&index=0&blockType=spec&lang=md"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__